export default __webpack_public_path__ + "static/media/PPI-steps-004.29e485ee.jpg";